import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-div-reset-password" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "medium-text-white message" }, "Reset your password", -1)
const _hoisted_3 = { class: "input-password-div" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_input_field = _resolveComponent("input-field")!
  const _component_Form = _resolveComponent("Form")!
  const _component_ta_button = _resolveComponent("ta-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_Form, { class: "form" }, {
        default: _withCtx(() => [
          _createVNode(_component_input_field, {
            class: "small-text-grey input-field-password",
            onKeyup: _withKeys(_ctx.updatePassword, ["enter"]),
            placeholder: _ctx.inputFieldNewPasswordPlaceholder,
            type: _ctx.passwordType,
            required: true,
            errorMessage: _ctx.errorMessage,
            showPasswordIcon: "",
            onPasswordReveal: _ctx.showPassword,
            onInput: _ctx.receivePassword,
            allowPasswordRules: "",
            showHint: ""
          }, null, 8, ["onKeyup", "placeholder", "type", "errorMessage", "onPasswordReveal", "onInput"]),
          _createVNode(_component_input_field, {
            class: "small-text-grey input-field-confirmed-password",
            onKeyup: _withKeys(_ctx.updatePassword, ["enter"]),
            placeholder: _ctx.inputFieldReEnterNewPasswordPlaceholder,
            type: _ctx.passwordType,
            required: true,
            errorMessage: _ctx.errorMessage,
            showPasswordIcon: "",
            onPasswordReveal: _ctx.showPassword,
            onInput: _ctx.receiveConfirmedPassword,
            allowPasswordRules: "",
            showHint: ""
          }, null, 8, ["onKeyup", "placeholder", "type", "errorMessage", "onPasswordReveal", "onInput"])
        ]),
        _: 1
      }),
      _createVNode(_component_ta_button, {
        class: "confirm-new-password-button",
        text: _ctx.confirmNewPasswordButtonText,
        backgroundColor: _ctx.buttonBackgroundColor,
        enableLoading: _ctx.enableButtonLoader,
        onClick: _ctx.updatePassword
      }, null, 8, ["text", "backgroundColor", "enableLoading", "onClick"])
    ])
  ]))
}